import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

/**
 * Phase 25.1.1 — Guided-workflow "what's next?" card.
 *
 * Sits directly under the workflow stepper so the Accounting User can
 * always see the recommended next step from anywhere on the detail page.
 */
export function NextActionCard({ nextAction, onClick, disabled = false }) {
  if (!nextAction) return null;
  const isDisabled = disabled || nextAction.disabled;

  return (
    <div
      className="flex items-center justify-between gap-4 rounded-lg border border-slate-900/10 bg-gradient-to-r from-slate-900 to-slate-800 p-4 text-white shadow-sm"
      data-testid="next-action-card"
      data-action-key={nextAction.key}
    >
      <div className="flex items-start gap-3">
        <div className="mt-0.5 rounded-full bg-white/10 p-2">
          <Sparkles size={16} />
        </div>
        <div>
          <div className="text-xs uppercase tracking-wide text-white/60">Next action</div>
          <div className="text-sm font-semibold">{nextAction.label}</div>
          {nextAction.description && (
            <div className="mt-0.5 text-xs text-white/70">{nextAction.description}</div>
          )}
        </div>
      </div>
      {onClick && (
        <Button
          onClick={onClick}
          disabled={isDisabled}
          size="sm"
          variant="secondary"
          className="shrink-0"
          data-testid={`next-action-btn-${nextAction.key}`}
        >
          {isDisabled ? 'Coming soon' : (<>Continue <ArrowRight size={14} className="ml-1" /></>)}
        </Button>
      )}
    </div>
  );
}

export default NextActionCard;
